// extracted by mini-css-extract-plugin
module.exports = {"section-banner":"banner_section-banner__6iQxI","grid":"banner_grid__XrxMs","form":"banner_form__ed9i7","image":"banner_image__OaC3i","phAnimation":"banner_phAnimation__aNp6l"};